import { Routes } from "@blitzjs/next"
import { ParsedPaywall } from "../mutations/createPaywall"
import { TemplateURLHelper } from "app/paywallBuilderV2/helpers"
import { RouteUrlObject } from "blitz"
import { EditorServiceHelper } from "@superwall-me/schema"
import { env } from "app/core/env"

export type DuplicatablePaywall = Pick<ParsedPaywall, "applicationId" | "id" | "url" | "v4">

const getEditorRouteByPaywall = <T extends DuplicatablePaywall | undefined>({
  paywall,
}: {
  paywall: T
}): T extends undefined ? undefined : RouteUrlObject => {
  if (!paywall) return undefined as T extends undefined ? undefined : RouteUrlObject
  const { applicationId, id: paywallId, url, v4 } = paywall
  if (v4) {
    const editorURL = new EditorServiceHelper(env).editorURL({
      applicationId,
      paywallId: paywall.id,
      version: "latest",
    })
    let url: URL
    try {
      url = new URL(editorURL)
    } catch (e) {
      const origin =
        typeof window !== "undefined" ? window.location.origin : "https://superwall.com"
      url = new URL(origin + editorURL)
    }
    const parsedQuery = Object.fromEntries(url.searchParams)

    return {
      href: url.toString(),
      pathname: url.pathname,
      query: parsedQuery,
    } as T extends undefined ? undefined : RouteUrlObject
  }

  const templateURLHelper = new TemplateURLHelper(url)
  const version =
    templateURLHelper.parts?.base != undefined && templateURLHelper.parts?.base != "base1"
      ? "v3"
      : "v2"

  switch (version) {
    case "v3":
      return Routes.ShowPaywallPageV3({
        applicationId,
        paywallId,
      }) as T extends undefined ? undefined : RouteUrlObject
    case "v2":
      return Routes.ShowPaywallPageV2({
        applicationId,
        paywallId,
      }) as T extends undefined ? undefined : RouteUrlObject
  }
}

export default getEditorRouteByPaywall
